import Flex from "@irati/ui/src/Flex"
import theme from "@irati/ui/src/global/theme"
import {ButtonLink, ButtonRouterLink} from "@irati/ui/src/Link"
import {Body, H1} from "@irati/ui/src/Typography"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import React, {FC} from "react"
import {BenefitHeaderContainer, BenefitHeaderLogo} from "../../styled"

interface Props {
  title?: string
  subtitle?: string
  firstCtaTitle?: string
  firstCtaUrl?: string
  secondCtaUrl?: string
  secondCtaTitle?: string
  isExternal?: boolean
  imageSrc?: string
  alt?: string
}

export const BenefitHeader: FC<Props> = ({
  title,
  subtitle,
  firstCtaTitle,
  secondCtaTitle,
  imageSrc,
  alt,
  firstCtaUrl,
  secondCtaUrl,
  isExternal
}) => {
  const {formatMessage} = useIntl()
  return (
    <Flex justifyContent="center">
      <BenefitHeaderContainer>
        <div>
          {title && (
            <H1 color={theme.colors.primary2}>
              <FormattedMessage id={title} />
            </H1>
          )}
          {subtitle && (
            <Body color={theme.colors.greys.grey50} large>
              <FormattedMessage id={subtitle} />
              {imageSrc && <BenefitHeaderLogo src={formatMessage({id: imageSrc})} alt={alt} />}
            </Body>
          )}
        </div>
        <Flex gap={1} direction="row" alignItems="center" justifyContent="flex-end">
          {firstCtaTitle &&
            (isExternal ? (
              <ButtonLink href={firstCtaUrl} target="_blank" onClick={() => {}}>
                <FormattedMessage id={firstCtaTitle} />
              </ButtonLink>
            ) : (
              <ButtonRouterLink to={formatMessage({id: firstCtaUrl})} onClick={() => {}}>
                <FormattedMessage id={firstCtaTitle} />
              </ButtonRouterLink>
            ))}
          {secondCtaTitle &&
            (isExternal ? (
              <ButtonLink href={secondCtaUrl} target="_blank" primary onClick={() => {}}>
                <FormattedMessage id={secondCtaTitle} />
              </ButtonLink>
            ) : (
              <ButtonRouterLink to={formatMessage({id: secondCtaUrl})} primary onClick={() => {}}>
                <FormattedMessage id={secondCtaTitle} />
              </ButtonRouterLink>
            ))}
        </Flex>
      </BenefitHeaderContainer>
    </Flex>
  )
}
